import { render, staticRenderFns } from "./ConverList.vue?vue&type=template&id=4bf20e7f&scoped=true"
import script from "./ConverList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConverList.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ConverList.vue?vue&type=style&index=0&id=4bf20e7f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf20e7f",
  null
  
)

export default component.exports